const LightningBolt = () => {
  return (
    <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M5.57939 13.4554L13.75 2.25L12.3744 8.8987C12.3102 9.209 12.5472 9.5 12.864 9.5H18.0239C18.4314 9.5 18.6678 9.96141 18.4297 10.2922L10 22L11.1565 14.8296C11.2055 14.5256 10.9708 14.25 10.6629 14.25H5.98339C5.57446 14.25 5.33846 13.7858 5.57939 13.4554Z"
        fill="#99CE99"
      />
      <path
        d="M13.3462 1.95548C13.4848 1.76541 13.7375 1.69821 13.9526 1.79337C14.1676 1.88884 14.2874 2.12158 14.2397 2.35197L12.8647 9.0004H18.0239C18.8388 9.00067 19.3116 9.923 18.8354 10.5844L10.4067 22.2924C10.2713 22.4804 10.0232 22.5506 9.80907 22.4623C9.59512 22.3737 9.47054 22.149 9.50732 21.9203L10.6636 14.7504H5.98388C5.16603 14.7504 4.69443 13.8224 5.17626 13.1615L13.3462 1.95548ZM5.98388 13.7504H10.6636C11.2791 13.7507 11.7488 14.3018 11.6509 14.9096L10.8306 19.9906L18.0239 10.0004H12.8647C12.2312 10.0004 11.7573 9.41862 11.8852 8.79825L12.7925 4.41251L5.98388 13.7504Z"
        fill="#004400"
      />
    </svg>
  );
};

export default LightningBolt;
